module.exports = __webpack_public_path__ + "static/media/30.d47e99ad.wav";